import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import { LMap, LTileLayer, LMarker,LControlLayers,LTooltip, LPopup } from 'vue2-leaflet';
import { Icon } from 'leaflet';
//import 'leaflet-routing-machine/dist/leaflet-routing-machine';
import 'leaflet/dist/leaflet.css';
//import 'leaflet-routing-machine/dist/leaflet-routing-machine.css';
import 'leaflet-control-geocoder/dist/Control.Geocoder';
import "leaflet-contextmenu/dist/leaflet.contextmenu.css";
import "leaflet-contextmenu/dist/leaflet.contextmenu.js";
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet-draw/dist/leaflet.draw.js";
import VueToasted from 'vue-toasted';


Vue.use(VueToasted)

Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);
Vue.component("l-popup", LPopup);
Vue.component("l-tooltip", LTooltip);
Vue.component("l-control-layers", LControlLayers);

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
